import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { ScrollManager } from './components/ScrollManager';
import { CaseStudyAccessProvider } from './contexts/CaseStudyAccessContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Home } from './pages/Home';
import { KordisCaseStudy } from './pages/KordisCaseStudy';
import { ClearDocsCaseStudy } from './pages/ClearDocsCaseStudy';
import { PalacioCaseStudy } from './pages/PalacioCaseStudy';
import { VendooCaseStudy } from './pages/VendooCaseStudy';
import { BotkeeperCaseStudy } from './pages/BotkeeperCaseStudy';
import { CognitiveBiases } from './pages/CognitiveBiases';
import { CoffeeTable } from './pages/CoffeeTable';
export function App() {
  return <ThemeProvider data-id="element-0" data-mp="28tw9l3rof699">
    <MotionConfig reducedMotion="user" data-id="element-1" data-mp="28te4dhn1dhp7">
      <BrowserRouter data-id="element-2" data-mp="28s2xva27hvue">
        <ScrollManager data-id="element-3" data-mp="23vkv2fqfs7kp" />
        <CaseStudyAccessProvider data-id="element-4" data-mp="23u9t8lgjx9w8">
          <Routes data-id="element-5" data-mp="23v2tr4ox335x">
            <Route path="/" element={<Home data-id="element-7" data-mp="3ikh7o8icgqyg" />} data-id="element-6" data-mp="23ti67z10skhk" />
            <Route path="/work/kordis" element={<KordisCaseStudy data-id="element-9" data-mp="3ihv2ugmu8pjx" />} data-id="element-8" data-mp="3iiwg8rrbto4t" />
            <Route path="/work/clear-docs" element={<ClearDocsCaseStudy data-id="element-11" data-mp="3mk83wrqn3zad" />} data-id="element-10" data-mp="3mlatmwc87vop" />
            <Route path="/work/palacio-de-hierro" element={<PalacioCaseStudy data-id="element-13" data-mp="3rdaselgk8ijp" />} data-id="element-12" data-mp="3mj6lg27aoaim" />
            <Route path="/work/vendoo" element={<VendooCaseStudy data-id="element-15" data-mp="5opiv1o0k3w" />} data-id="element-14" data-mp="3recdzjv7cnfo" />
            <Route path="/work/botkeeper" element={<BotkeeperCaseStudy data-id="element-17" data-mp="7svdij4jt6t" />} data-id="element-16" data-mp="4n5w26l2pak" />
            <Route path="/playground/cognitive-biases" element={<CognitiveBiases data-id="element-19" data-mp="2zn6biws0edn8" />} data-id="element-18" data-mp="2zlv7cvunj3vl" />
            <Route path="/playground/coffee-table" element={<CoffeeTable data-id="element-21" data-mp="33n6wl09m5n39" />} data-id="element-20" data-mp="33m5be2yvvk7t" />
            <Route path="*" element={<Home data-id="element-23" data-mp="38l8gtoirzsgb" />} data-id="element-22" data-mp="38lromcepp0gm" />
          </Routes>
        </CaseStudyAccessProvider>
      </BrowserRouter>
    </MotionConfig>
    </ThemeProvider>;
}